import { Injectable } from '@angular/core';
import { PrepTourDefinition } from './tour.types';

/**
 * Registry of guide definitions so a guide can be started by id from a
 * different part of the app than the one that built it (the remediation
 * screen registers the workbench leg; the workflow service starts it).
 */
@Injectable({ providedIn: 'root' })
export class PrepGuideRegistry {
  private readonly guides = new Map<string, PrepTourDefinition>();

  register(...defs: PrepTourDefinition[]): void {
    defs.forEach((d) => this.guides.set(d.id, d));
  }

  unregister(id: string): void {
    this.guides.delete(id);
  }

  get(id: string): PrepTourDefinition | undefined {
    return this.guides.get(id);
  }

  ids(): string[] {
    return Array.from(this.guides.keys());
  }
}
